import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const L2eMonthlyConfigActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

L2eMonthlyConfigActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

L2eMonthlyConfigActions.defaultProps = {
  basePath: '',
  data: {},
};

export default L2eMonthlyConfigActions;
